export default "__VITE_ASSET__jxyFVQwy__"